import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { MeasurementQcEnvProvider } from '@monorepo/services';
import {
  TFetchBctxDetailsByPerPieceTagIdRequest,
  TMqcBctx,
  TSizeMeasurementQc,
  TMqcApiResStatus,
  TCurrentScannedTagDetails,
  TSavePerPieceTagMeasurementQCRequest,
  TSavePerPieceTagMeasurementQCResponse,
  TAddOrUpdateThresholdRequest,
  TTransformedFetchBctxDetailsByPerPieceTagIdResponse,
  TAddOrUpdateThresholdResponse,
  TMeasurementQcTransactionLogResponse,
  TMeasurementQcTransactionLogRequest,
  TUndoPerPieceMeasurementRequest,
  TUndoPerPieceMeasurementResponse,
  TREQUEST_MeasurementPointsByBctx,
  TMeasurement_issue,
} from '@monorepo/types';

type TFetchBctxDetailsByPerPieceTagIdResponse = TMqcBctx & {
  status: TMqcApiResStatus;
  factoryId: string;
  currentScannedTagDetails: TCurrentScannedTagDetails;
  sizesMeasurementQC: TSizeMeasurementQc[];
  updatedBy: string;
  updatedAt: number;
  error: string | null;
};

@Injectable({
  providedIn: 'root',
})
export class MeasurementQcDataProvider {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private measurementQcEnvProvider: MeasurementQcEnvProvider) {}

  transformMqcBctxResponse(
    res: TFetchBctxDetailsByPerPieceTagIdResponse,
  ): TTransformedFetchBctxDetailsByPerPieceTagIdResponse {
    const {
      buyer,
      style,
      po,
      product_type,
      product_category,
      color,
      erp,
      order_ref,
      status,
      factoryId,
      currentScannedTagDetails,
      sizesMeasurementQC,
      updatedBy,
      updatedAt,
      error,
    } = res;

    return {
      bctxDetails: {
        buyer,
        style,
        po,
        product_type,
        product_category,
        color,
        erp,
        order_ref,
      },
      status,
      factoryId,
      currentScannedTagDetails,
      sizesMeasurementQC,
      updatedBy,
      updatedAt,
      error,
    };
  }

  getBctxDetailsByTagId(payload: TFetchBctxDetailsByPerPieceTagIdRequest) {
    const url = this.measurementQcEnvProvider.getEnvVar('GET_MQC_BCTX_DETAILS_BY_TAG_ID');
    return this.http
      .post<TFetchBctxDetailsByPerPieceTagIdResponse>(url, payload, this.httpOptions)
      .pipe(map(this.transformMqcBctxResponse));
  }

  updateMqcThresholdOfBctx(payload: TAddOrUpdateThresholdRequest) {
    const url = this.measurementQcEnvProvider.getEnvVar('UPDATE_MQC_THRESHOLD_OF_BCTX');
    return this.http.post<TAddOrUpdateThresholdResponse>(url, payload, this.httpOptions);
  }

  savePerPieceTagMeasurements(payload: TSavePerPieceTagMeasurementQCRequest) {
    const url = this.measurementQcEnvProvider.getEnvVar('SAVE_PER_PIECE_TAG_MEASUREMENTS');
    return this.http.post<TSavePerPieceTagMeasurementQCResponse>(url, payload, this.httpOptions);
  }

  fetchMeasurementQcTransactionLog(payload: TMeasurementQcTransactionLogRequest) {
    const url = this.measurementQcEnvProvider.getEnvVar('FETCH_MEASUREMENT_QC_TRANSACTION_LOG');
    return this.http.post<TMeasurementQcTransactionLogResponse>(url, payload, this.httpOptions);
  }

  undoPerPieceMeasurement(payload: TUndoPerPieceMeasurementRequest) {
    const url = this.measurementQcEnvProvider.getEnvVar('UNDO_PER_PIECE_MEASUREMENT');
    return this.http.post<TUndoPerPieceMeasurementResponse>(url, payload, this.httpOptions);
  }

  getMeasurementPointsBasedOnSize(request: TREQUEST_MeasurementPointsByBctx) {
    const url = this.measurementQcEnvProvider.getEnvVar('GET_MEASUREMENTS_LIST_BASED_ON_SIZE');
    return this.http.post<TMeasurement_issue[]>(url, request, this.httpOptions);
  }
}
